import React, { useContext } from 'react';
import './ProfileCard.css';
import { defaultProfileImage } from '../DefaultImage';
import { CardContext } from '../../../store/CardContext';
import { Link } from "react-router-dom";
import { TbArrowsExchange } from "react-icons/tb";
import ExchangeContact from "../../Common/exchangeContactModal/ExchangeContact";
import { useQueryClient } from '@tanstack/react-query';
import { updateTapCount } from '../../../helpers/tapCountMutation';
function ProfileCard({ card, Highlightcolor, Textcolor, preview, Iconcolor, BtIColor, profileCardColor, theme }) {

  const [cardData] = useContext(CardContext);


  const { profileImage, personalDetails, checkProfile, contactDetails, vCard } = cardData;

  const array = personalDetails?.name ? personalDetails?.name?.split(" ") : "";
  function isDarkColor(color) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // Calculate brightness of the color (uses a common formula)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    // Consider color dark if brightness is below 128
    return brightness < 128;
  }
  const exchangeButton = (
    <button
      className=" flex items-center justify-center p-2 gap-3 w-full text-[12px]  h-[45px] rounded-[40px]"
      style={{
        border: "2px solid ",
        borderColor: `${Highlightcolor ? Highlightcolor : "black"}`,
        color: `${Highlightcolor ? Highlightcolor : "black"}`,
      }}
    >
      <TbArrowsExchange className="w-4 h-4" />
      Exchange Contacts
    </button>
  )


  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };

  return (
    <div className='profileCard'>
        <div
              className="relative rounded-lg overflow-hidden  mb-5 shadow-lg"
              style={{
                backgroundColor: Highlightcolor || "#000",
             
                height: "300px",
                objectFit: "cover",
              }}
            >
              {card?.checkProfile && (
                <>
                <img
                  src={card?.profileImage || defaultProfileImage}
                  alt="Profile"
                  // className="w-[100%] object-cover h-[100%] "
                />
                <h1>hdhdhd</h1>
                </>

              )}

              <div
                className="absolute bottom-0 left-0 right-0 rounded-[8px] flex items-center justify-center p-4"
                style={{
                  backgroundColor: Highlightcolor
                    ? `${Highlightcolor}`
                    : "rgba(0, 0, 0, 0.5)",
                    color: isDarkColor(Highlightcolor) ? "white" : "black",
                }}


              >
                <div className="flex flex-col justify-center text-center" style={{  color: isDarkColor(Highlightcolor) ? "white" : "black",}}>
                  <h1
                    className="font-bold"
                    style={{
                      fontSize: array[0]?.length > 9 ? "18px" : "20px",
                      lineHeight: "1.2",
                      color: isDarkColor(Highlightcolor) ? "white" : "black",
                    }}
                  >
                    {card?.name}
                  </h1>
                  <p className="text-[12px]" style={{
                    color: isDarkColor(Highlightcolor) ? "white" : "black",
                  }}>{card?.companyDesignation}</p>
                </div>
              </div>

       
            </div>
      <div className="flex items-center w-full justify-center mt-3 mb-4 gap-[10px] pl-2 pr-2">
        <Link
          onClick={() => handleTap('saveContact')}
          to={`${preview ? vCard : ""}`}
          // target={`${preview ? "_blank" : ""}`}
          className={`blk-btn flex ${card?.exchangeContact?.show ? 'w-6/12' : 'w-full'}`}
        >
          <button
            className="flex justify-center items-center p-2 gap-2 w-full h-[45px] rounded-[40px]"
            style={{
              background: `${Highlightcolor ? Highlightcolor : "black"}`,
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.833 9.16683H10.833V4.16683C10.833 3.94582 10.7452 3.73385 10.5889 3.57757C10.4326 3.42129 10.2207 3.3335 9.99967 3.3335C9.77866 3.3335 9.5667 3.42129 9.41042 3.57757C9.25414 3.73385 9.16634 3.94582 9.16634 4.16683V9.16683H4.16634C3.94533 9.16683 3.73337 9.25463 3.57709 9.41091C3.42081 9.56719 3.33301 9.77915 3.33301 10.0002C3.33301 10.2212 3.42081 10.4331 3.57709 10.5894C3.73337 10.7457 3.94533 10.8335 4.16634 10.8335H9.16634V15.8335C9.16634 16.0545 9.25414 16.2665 9.41042 16.4228C9.5667 16.579 9.77866 16.6668 9.99967 16.6668C10.2207 16.6668 10.4326 16.579 10.5889 16.4228C10.7452 16.2665 10.833 16.0545 10.833 15.8335V10.8335H15.833C16.054 10.8335 16.266 10.7457 16.4223 10.5894C16.5785 10.4331 16.6663 10.2212 16.6663 10.0002C16.6663 9.77915 16.5785 9.56719 16.4223 9.41091C16.266 9.25463 16.054 9.16683 15.833 9.16683Z"
                fill={isDarkColor(Highlightcolor) ? "white" : "black"}
              />
            </svg>
            <p
              className="text-[12px] m-0 font-medium items-center"
              style={{
                color: `${isDarkColor(Highlightcolor) ? "white" : "black"}`,
              }}
            >
              Add contact
            </p>
          </button>
        </Link>

        {card?.exchangeContact?.show ? (
          <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
        ) : null}
      </div>

    </div>
  );
}

export default ProfileCard;
